import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppVersionComponent } from './version/version.component';
import { AuthModule } from './auth/auth.module';
import { StrategiesModule } from './strategies/strategies.module';
import { AppConfigModule } from './app-config.module';
import { ResourcesModule } from './resources/resources.module';
import { httpInterceptorProviders } from './http-interceptors';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AuthModule,
    StrategiesModule,
    AppConfigModule,
    ResourcesModule
  ],
  declarations: [
    AppComponent,
    AppVersionComponent
  ],
  providers: [
    httpInterceptorProviders
  ],
  exports: [
  ],
  bootstrap: [ AppComponent ],
})

export class AppModule {}
